module.exports = __webpack_public_path__ + "img/config.35a744b7.svg";